import { TileProps } from '../coverage-screen';
import { CoverageScreenType } from './coverage-type';

const outboundLinks = {
  glassLinks: [
    {
      title: 'Safelite*',
      description: 'Auto glass services for your every need',
      link: 'https://www.safelite.com/',
      buttonType: 'appointment',
      disclaimer: '*[Safelite] is a mobile vendor. Visit their website to confirm their service locations.',
    },
  ],
  repairLinks: [
    {
      title: 'Firestone',
      description: 'Offers auto repair, maintenance, battery replacement and tire replacement',
      link: 'https://www.firestonecompleteautocare.com/',
      buttonType: 'website',
    },
  ],
  cosmeticLinks: [], // Cosmetic links are swapped for a PreferredPartnerForm component
  keysLinks: [
    {
      title: 'Car Keys Express',
      description: 'On-site key replacement for businesses and consumers',
      link: 'https://carkeysexpress.com/',
      buttonType: 'website',
    },
  ],
};

export const getOutboundLink = (coverageScreenType: CoverageScreenType): TileProps[] => {
  const CoverageScreenLinks = {
    contactUs: [],
    limited100Covered: [],
    manufacturerCovered: [],
    carvanaCareCovered: [],
    carvanaCareOilTireCovered: [],
    notCovered: outboundLinks.repairLinks,
    thirtyDayCovered: [],
    conditionallyCoveredBrakes: outboundLinks.repairLinks,
    notCoveredCosmetic: outboundLinks.cosmeticLinks,
    notCoveredGlass: outboundLinks.glassLinks,
    notCoveredAdditionalCosmetic: outboundLinks.cosmeticLinks,
    notCoveredAdditionalKey: outboundLinks.keysLinks,
    notCoveredMissingAccessories: [],
    cosmeticSubmitted: [],
    carvanaCareRoadHazardCovered: [],
    carvanaCareRoadHazardNotCovered: outboundLinks.repairLinks,
    carvanaCareOilChangeCovered: [],
    carvanaCareDentCovered: [],
    carvanaCareOilChangeNotCovered: outboundLinks.repairLinks,
  };

  return CoverageScreenLinks[coverageScreenType] as any;
};
